<template>
    <v-container fluid>
      <material-card icon="mdi-calendar" title="Academic Calender">

        <v-card flat class="pb-4">
          <v-card-text class="pt-0 pr-1">
             <v-tabs v-model="tab">
              <v-tab key="Calender Creation" @click="resetAll"> Academic Calender Creation </v-tab>
              <v-tab key="Calender Listing" @click="resetAll"> Academic Calender Listing </v-tab>
            </v-tabs>
            <v-divider class="my-0"></v-divider>
          </v-card-text>
          <v-tabs-items v-model="tab" >
            <v-tab-item key="Calender Creation">
              <v-card>
                <v-card-title>
                  <v-row>
                    <v-col cols="3">
                      <v-autocomplete placeholder="Please select Academic Year" class="my-0 py-1"
                        label="Academic Year*" v-model="academicYear" required
                        item-value="id" :items="academicYears" key="id" item-text="academicYear" @change="emptyDatePicker">
                      </v-autocomplete>
                    </v-col>
                     <v-col cols="3">
                      <v-autocomplete
                        class="my-0 py-1"
                        label="Select Business"
                        placeholder="--Select--"
                        name="businessSelect"
                        required
                        v-model="selectedBusinessID"
                        item-value="id"
                        :items="business"
                        key="id"
                        item-text="name"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete
                        key="id"
                        class="my-0 py-1"
                        label="Select Zone"
                        :items="zones"
                        v-model="selectedZones"
                        item-text="name"
                        :hide-details="true"
                        @change="getZoneWiseFranchisee()"
                        return-object
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete
                        class="my-0 py-1"
                        label="Select Centers"
                        :items="zoneWiseFranchisees"
                        v-model="selectedCenter"
                        item-text="companyName"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="2">
                       <v-dialog ref="dialog1" v-model="modal" :return-value.sync="startDate" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field label="From Month*" v-model="startDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="startDate" scrollable type='month' :min="minDate" :max="maxDate">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog1.save(startDate),enableButton()">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                     <v-col cols="2">
                      <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field label="To Month*" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="toDate" scrollable type='month' :min="minDate" :max="maxDate">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal1 = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(toDate),enableButton()">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="3">
                      <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" medium @click ="getHolidayName" :disabled=disabled>Start Calender Creation</v-btn>
                      <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" medium @click="resetAll">Reset</v-btn>

                    </v-col>
                    <v-col cols="2">
                      <v-btn class="px-2 ml-1 ma-1" min-width="0" @click="dialogToAddMoreCustomization()" medium>Add More Customization</v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                  <v-row>
                    <v-col  cols="auto" v-for="(eventType,index) in eventTypeList" :key="index">
                        <v-btn :color="eventType.eventColorCode" @click="openCalendar(eventType.id)" medium>{{eventType.eventName}}</v-btn>
                    </v-col>
                  </v-row>
                <v-col cols="12" md="12" lg="12" sm="12">
                <v-card class="pa-1 elevation-0">
                  <v-row style="border:solid 1px #000;" no-gutters>
                    <v-slide-group
                      class="pa-4"
                      active-class="success"
                      show-arrows
                    >
                      <v-slide-item
                        v-for="(calenderObj, index) in academicCalenderArray"
                        :key=index
                        v-slot="{  }"
                      >
                        <v-card
                          width="100%"
                        >
                        <div class="table-border-right"
                          style="width:250px;"

                        >
                          <!--Start Month Header-->
                          <v-row class="table-border" no-gutters>
                            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                              <v-toolbar
                                elevation="0"
                                height="30px"
                                style="background-color: #5d58ef"
                              >
                                <div class="table-header">{{calenderObj.monthName}}</div>
                              </v-toolbar>
                            </v-col>
                          </v-row>
                          <!--End Month Header-->
                          <!--Start Header Design-->
                          <v-row class="table-border" no-gutters>
                            <v-col
                              v-for="(headers, headerIndex) in calenderObj.headers"
                              :key="`${headerIndex}_${index}`"
                              class="d-flex justify-center table-border-right"
                              cols="12"
                              :md="(headers === 'activity') ? '6' : '3'"
                              :lg="(headers === 'activity') ? '6' : '3'"
                              :sm="(headers === 'activity') ? '6' : '3'"
                            >
                              {{headers}}
                            </v-col>
                          </v-row>
                          <!--End Header Design-->
                          <!--Start Day Loop Design-->
                          <v-row v-for="(day, daysIndex) in calenderObj.daysInMonth" :key="`${daysIndex}_${day}`" class="table-border" :class="{'grey-bg': isWeekend(day, calenderObj.monthName)}" no-gutters>
                            <v-col class="d-flex justify-center table-border-right" cols="12" md="3" lg="3" sm="3">{{day}}</v-col>
                            <v-col class="d-flex justify-center table-border-right" cols="12" md="3" lg="3" sm="3">{{getDayFromMonthYear(day, calenderObj.monthName)}}</v-col>
                            <v-col class="d-flex justify-center" :style="`background-color:${getActivityName(day,calenderObj.monthName).activityColor}`" cols="12" md="6" lg="6" sm="6" xs="5">{{getActivityName(day,calenderObj.monthName).activityName}}</v-col>
                          </v-row>
                          <!--End Day Loop Design-->
                        </div>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-row>
                </v-card>
              </v-col>
              </v-card>
            </v-tab-item>
            <v-tab-item key="Calender Listing">
              <v-card>
                <v-card-title>
                  <v-row>
                    <v-col cols="2">
                      <v-autocomplete placeholder="Please select Academic Year" class="my-0 py-1"
                        label="Academic Year*" v-model="academicYear" required
                        item-value="id" :items="academicYears" key="id" item-text="academicYear">
                      </v-autocomplete>
                    </v-col>
                     <v-col cols="2">
                      <v-autocomplete
                        class="my-0 py-1"
                        label="Select Business"
                        placeholder="--Select--"
                        name="businessSelect"
                        required
                        v-model="selectedBusinessID"
                        item-value="id"
                        :items="business"
                        key="id"
                        item-text="name"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2">
                      <v-autocomplete
                        key="id"
                        class="my-0 py-1"
                        label="Select Zone"
                        :items="zones"
                        v-model="selectedZones"
                        item-text="name"
                        :hide-details="true"
                        @change="getZoneWiseFranchisee()"
                        return-object
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-autocomplete
                        class="my-0 py-1"
                        label="Select Centers"
                        :items="zoneWiseFranchisees"
                        v-model="selectedCenter"
                        item-text="companyName"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="2">
                      <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" medium @click="getHolidayName">Search
                     </v-btn>
                      <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" medium @click="resetAll">Reset</v-btn>
                    </v-col>

                  </v-row>
                </v-card-title>
                 <v-data-table
                    :headers="headers"
                    :items="holidayList"
                  >

                  <template v-slot:item.actions="{ item }">
                    <!-- <router-link :to="{ name: 'ViewUser', params: { adminUserID: item.id } }"> -->
                      <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                        <v-icon color="black" small> mdi-eye</v-icon>
                      </v-btn>
                    <!-- </router-link> -->
                    <router-link target="_blank" :to="{ name: 'editAcademicCalender', params: { academicCalendarID: item.id } }">
                      <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                        <v-icon small> mdi-pencil</v-icon>
                      </v-btn>
                    </router-link>

                    <!-- <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt" @click.prevent="deleteUser(item.id)"> -->
                    <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small>
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                    <!-- <v-btn class="px-2 ml-1 ma-1" color="primary" min-width="0" small v-if="!item.deletedAt" @click.prevent="deleteUser(item.id)"> -->
                    <v-btn class="px-2 ml-1 ma-1" color="primary" min-width="0" small>
                      <v-icon small> mdi-download</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
                 </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </material-card>
      <v-dialog v-model="dialog" max-width="500" max-height="700">
      <v-date-picker
        multiple
        v-model="selectedDates"
        :width="460"
        :height="700"
      >
        <div v-if="selectedDates.length > 0">
          <v-row>
            <v-col cols="12" sm="12">
              <h3>Selected Dates:</h3>
            </v-col>
            <div v-for="(date, index) in selectedDates" :key="index" class="selected-date">
              <v-col>
              <span>{{ date }}</span>
              </v-col>
              <v-col cols=auto>
              <v-combobox v-model="textFields[date]" placeholder="Press enter after adding" label="Enter Holiday Name" class="my-0 py-1" multiple chips></v-combobox>
              </v-col>
            </div>
            <v-col cols="12">
              <v-card-actions class="justify-end">
                <v-btn color="success" @click="addHoliday()">Save</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </div>
      </v-date-picker>

      </v-dialog>
      <!--dialog box to add customized event button starts-->
      <v-dialog v-model="dialogToAddEvent" max-width="500" max-height="700">
         <form @submit.prevent="saveEventType">
            <v-card>
              <v-toolbar dark color="darkblue">
                <v-toolbar-title> Customize </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="dialogToAddEvent=false, clearAll()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                  <label class="font-weight-medium body-2">
                    Event Type :
                    <span class="requir error--text">*</span>
                  </label>
                  <v-text-field class="my-0 py-1" maxlength="100" v-model="eventTypeName" counter="100" placeholder="Enter valid character" required></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="font-weight-medium body-2">
                    Select Color For Event :
                    <span class="requir error--text">*</span>
                  </label>
                   <v-color-picker v-model="selectedColor"></v-color-picker>
                </v-col>
                  <v-col cols="12">
                    <v-card-actions class="justify-end">
                      <v-btn color="success" type="submit">Save</v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </form>
      </v-dialog>
      <!--dialog box to add customized event button ends--->
    </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
export default {
  name: 'academicCalender',
  components: { MaterialCard },
  data () {
    return {
      business: [],
      zones: [],
      selectedZones: '',
      selectedCenter: '',
      academicYear: '',
      selectedBusinessID: '',
      zoneWiseFranchisees: [],
      academicYears: [],
      enableCustomizationModal: false,
      enableDatePickerModal: false,
      date: 0,
      dialog: false,
      selectedDates: [],
      textFields: [],
      modal: false,
      modal1: false,
      startDate: '',
      toDate: '',
      holidayList: [],
      academicCalenderArray: [],
      monthNames: '',
      headers: [
        { text: 'Academic Year', value: 'franchiseeAcademicYear.academicYear', sortable: true },
        { text: 'Business', value: 'curriculumBusinessProgramMap.curriculumBusiness.name', sortable: true },
        { text: 'Zone', value: 'zone.name', sortable: true },
        { text: 'Center', value: 'franchisee.companyName', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      dialogToAddEvent: false,
      tab: null,
      disabled: true,
      eventTypeName: '',
      selectedColor: '',
      eventTypeList: [],
      selectedEventTypeID: '',
      activityColor: ''

    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    }),
    minDate () {
      if (this.academicYear) {
        const selectedYear = this.academicYears.find(year => year.id === this.academicYear)
        if (selectedYear) {
          const [startYear] = selectedYear.academicYear.split('-')
          return `${startYear}-01`
        }
      }
      return null
    },
    maxDate () {
      if (this.academicYear) {
        const selectedYear = this.academicYears.find(year => year.id === this.academicYear)
        if (selectedYear) {
          const [, endYear] = selectedYear.academicYear.split('-')
          return `${endYear}-12`
        }
      }
      return null
    }
  },
  watch: {
    selectedDates: function (newVal) {
      newVal.forEach((item, index) => {
        if (typeof this.textFields[item] === 'undefined') {
          this.textFields[item] = []
        }
      })
    }
  },
  async created () {
    await this.getAcademicYears()
    await this.getBusinessList()
    await this.getZoneDetails()
    await this.getHolidayName()
    await this.getEventType()
  },
  methods: {
    openCalendar (eventTypeID) {
      this.selectedDates = []
      this.textFields = []
      this.dialog = true
      this.selectedEventTypeID = eventTypeID
    },
    isWeekend: function (dayNo, yearMonth) {
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let dayOfWeek = moment(date, 'DD MMMM YYYY').format('dddd')
      return dayOfWeek === 'Saturday' || dayOfWeek === 'Sunday'
    },

    enableButton: function () {
      if (this.startDate && this.toDate) {
        this.disabled = false
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYear = academicYear ? academicYear.id : ''
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    getHolidayName: async function () {
      try {
        this.isLoading = true
        this.academicCalenderArray = []
        let startMonth = moment(this.startDate, 'YYYY-MM')
        let endMonth = moment(this.toDate, 'YYYY-MM')
        let getPayloadData = {
          academicYearID: this.academicYear,
          franchiseeID: this.selectedCenter,
          zoneID: this.selectedZones.id,
          businessID: this.selectedBusinessID,
          startMonth: this.startDate,
          endMonth: this.toDate
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/academic-calender/get-holidays-list`, getPayloadData)
        this.holidayList = data

        if (endMonth.isBefore(startMonth)) {
          this.errMsg('End date must be greater than start date.')
          return false
        }
        endMonth = endMonth.add(1, 'month')
        while (startMonth.isBefore(endMonth)) {
          let monthActivityObj = {}
          monthActivityObj.monthName = moment(startMonth, 'YYYY-MM-DD').format('MMMM YYYY')
          monthActivityObj.headers = [
            'date',
            'day',
            'activity'
          ]
          let formattedMonth = moment(startMonth, 'YYYY-MM-DD').format('YYYY-MM')
          monthActivityObj.daysInMonth = moment(formattedMonth).daysInMonth()
          this.academicCalenderArray.push(monthActivityObj)
          startMonth.add(1, 'month')
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getBusinessList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/academic-calender/get-business`
        )
        if (data) {
          this.business = [data]
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneWiseFranchisee: async function () {
      try {
        let selectedZone = []
        this.selectedCenter = ''
        selectedZone.push(this.selectedZones.name)
        const data = await http.post(
          `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
          {
            zone: selectedZone
          }
        )
        this.zoneWiseFranchisees = data.data
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dialogToAddMoreCustomization: function () {
      this.dialogToAddEvent = true
    },

    clearAll: function () {
      this.enableCustomizationModal = !this.enableCustomizationModal
      this.enableDatePickerModal = !this.enableDatePickerModal
    },
    getDayFromMonthYear: function (dayNo, yearMonth) {
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let getDay = moment(date, 'DD MMMM YYYY').format('dddd').substring(0, 3)
      return getDay
    },
    getActivityName: function (dayNo, yearMonth) {
      let activityColor = ''
      let activityName = ''
      let holidayNames = []
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let activityDate = moment(date, 'DD MMMM YYYY').format('YYYY-MM-DD')
      this.holidayList.forEach(item => {
        let itemDate = moment(item.date, 'YYYY-MM-DD').format('YYYY-MM-DD')
        if (itemDate === activityDate) {
          holidayNames.push(item.holidayname)
          activityColor = item.academicCalendarEvent.eventColorCode
        }
      })
      activityName = holidayNames.join(', ')
      return { activityName, activityColor }
    },

    addHoliday: async function (eventTypeID) {
      try {
        this.isLoading = true
        if (this.selectedZones.id === undefined) {
          this.errMsg('Please select Zone!')
        } else if (this.selectedBusinessID === '' || this.selectedBusinessID === undefined) {
          this.errMsg('Please select Business!')
        } else {
          let payload = {
            academicYearID: this.academicYear,
            franchiseeID: this.selectedCenter,
            zoneID: this.selectedZones.id,
            businessProgramMapID: this.selectedBusinessID,
            dates: [],
            eventTypeID: this.selectedEventTypeID
          }
          let hasEmptyHolidayName = false

          this.selectedDates.forEach(item => {
            if (this.textFields[item].length === 0 || this.textFields[item] === undefined) {
              hasEmptyHolidayName = true
            }
          })
          if (hasEmptyHolidayName) {
            this.errMsg('Please enter a holiday name for all selected dates!')
            return
          } else {
            this.selectedDates.forEach(item => {
              let dateObj = {
                date: item,
                holidayName: this.textFields[item]
              }
              payload.dates.push(dateObj)
            })
            if (this.selectedCenter === '' || this.selectedCenter === undefined) {
              delete payload.franchiseeID
            }
            const data = await http.post(`${constants.API_URL}/api/academic-calender/add-holiday`, payload)
            if (data.data[0][0].output) {
              this.errMsg(data.data[0][0].output.payload.message)
            } else {
              this.okMsg('Holiday Saved successfully!')
            }

            this.getHolidayName()
            this.dialog = false
          }
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getEventType: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/academic-calendar/get-event`)
        this.eventTypeList = data
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    saveEventType: async function () {
      try {
        this.isLoading = true
        let payload = {
          eventName: this.eventTypeName,
          eventColorCode: this.selectedColor
        }
        await http.post(`${constants.API_URL}/api/academic-calendar/add-event`, payload)
        this.okMsg('Event type added successfully!')
        this.dialogToAddEvent = false
        this.getEventType()
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    resetAll: function () {
      this.selectedBusinessID = ''
      this.selectedZones = ''
      this.selectedCenter = ''
      this.startDate = ''
      this.toDate = ''
      this.zoneWiseFranchisees = []
      this.getHolidayName()
      this.disabled = true
    },
    emptyDatePicker () {
      this.startDate = ''
      this.toDate = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
  .selected-date {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .table-border{
  border-bottom:solid 1px #000
  }
  .table-border-right{
    border-right:solid 1px #000;
  }
  .table-header{
    width:100%;text-align:center; color:#FFFFFF
  }
  .grey-bg{
    background-color: #C7C6C1;
  }
  </style>
